import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

function AdminLink() {
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();
  const [isAdmin, setIsAdmin] = useState(false);
  const [checkingAdmin, setCheckingAdmin] = useState(false);
  const [adminCheckComplete, setAdminCheckComplete] = useState(false);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!isAuthenticated || isLoading) {
        setIsAdmin(false);
        setAdminCheckComplete(false);
        return;
      }

      setCheckingAdmin(true);
      try {
        const token = await getAccessTokenSilently();
        const res = await fetch(`/api/admin/check`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
        });

        if (res.ok) {
          const data = await res.json();
          setIsAdmin(data.isAdmin);
        } else {
          setIsAdmin(false);
        }
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsAdmin(false);
      } finally {
        setCheckingAdmin(false);
        setAdminCheckComplete(true);
      }
    };

    checkAdminStatus();
  }, [isAuthenticated, isLoading, getAccessTokenSilently]);

  // Show loading indicator while checking admin status
  if (checkingAdmin) {
    return (
      <li>
        <span style={{ color: '#666', fontSize: '0.9em' }}>Checking admin status...</span>
      </li>
    );
  }

  // Don't show anything if not admin
  if (!adminCheckComplete || !isAdmin) {
    return null;
  }

  return (
    <>
      <li>
        <Link to="/create-organization">Create Organization</Link>
      </li>
      <li>
        <Link to="/admin">Admin Panel</Link>
      </li>
    </>
    
  );
}

export default AdminLink;
